// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tabs__tabs_indicator___1t2Yo {\n    transition: 0.1s transform, 0.1s width, 0.1s background-color;\n}", ""]);
// Exports
exports.locals = {
	"tabs_indicator": "tabs__tabs_indicator___1t2Yo"
};
module.exports = exports;
